<template>
    <HeaderContent title="Directory Accommodation"/>
    <ActionContent ctaText="Accommodation" :filterDate="false" @action="modal = !modal " />
    <!-- <StatisticData title="Destination Statistics" :data="statistics" /> -->
    <AccommodationForm :modal="modal" @update:modal="modal = $event"></AccommodationForm>
    <DataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    </DataTable>

    <!-- AccommodationDetail -->
     <AccommodationDetail v-model="detailAccommodation.togle" :data="detailAccommodation.data" :title="detailAccommodation.title"></AccommodationDetail>
    
</template>

<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import AccommodationForm from './AccommodationForm.vue';
import DataTable from '@/components/DataTable.vue';
import accommodationDummy from '@/dummy-data/accommodation.js'
import AccommodationDetail from './action/AccommodationDetail.vue';

import { ref, } from 'vue';
export default{
    name : 'AccommodataionIndex',
    components : {HeaderContent, ActionContent, AccommodationForm, AccommodationDetail,DataTable},
    setup(){
        const modal = ref(false)
        const data = accommodationDummy
        const detailAccommodation = ref({
            title : '',
            data : []
        })
        const headers = ref([
            {key : 'id',label: 'ID',sortable: true,},
            {key : 'destination_code', label : 'Destination Code',sortable: true, },
            {key : 'hotel_name', label : 'Hotel Name',sortable: true, },
            {key : 'hotel_code', label : 'Hotel Code',sortable: true, },
            {key : 'room_type', label : 'Room Type',sortable: true, },
            {key : 'extrabed', label : 'Extra Bed',sortable: true, },
            {key : 'pax', label : 'Pax',sortable: true, },
            {key : 'price', label : 'Price',sortable: true, },
            {key : 'action', label : 'Action' },  
        ])
        const customActions = ref([
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                console.log('Edit action clicked for:', item);
                
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                console.log('Delete action clicked for:', item);
                
                }
            },
            
        ]);
        
        return {
            modal,
            headers,
            data,
            customActions,
            detailAccommodation,
        }
    }
}
</script>

<!-- <script setup>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import AccommodationForm from './AccommodationForm.vue';
import DataTable from '@/components/DataTable.vue';
import accommodationDummy from '@/dummy-data/accommodation.js'
import AccommodationDetail from './action/AccommodationDetail.vue';

import { ref, reactive, defineModel } from 'vue';

const modal = defineModel()

const detailAccommodation = reactive({
    togle : false,
    title : '',
    data : []
})
const headers = ref([
    {key : 'id',label: 'Id',sortable: true,},
    {key : 'destination_code', label : 'Destination Code',sortable: true, },
    {key : 'hotel_name', label : 'Hotel Name',sortable: true, },
    {key : 'hotel_code', label : 'Hotel Code',sortable: true, },
    {key : 'room_type', label : 'Room Type',sortable: true, },
    {key : 'extrabed', label : 'Extra Bed',sortable: true, },
    {key : 'pax', label : 'Pax',sortable: true, },
    {key : 'price', label : 'Price',sortable: true, },
    {key : 'action', label : 'Action' },  
])
const data = accommodationDummy
const customActions = ref([
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        console.log('Edit action clicked for:', item);
        
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Delete action clicked for:', item);
        
        }
    },
    
]);


</script> -->


